import axios from '../../plugins/FinanceiroInterceptor'

export const state = {
    filtros: null,
}

export const mutations = {
    SET_FILTROS(state, filtros) {
        state.filtros = filtros;
    },
}

export const getters = {
    getFiltros(state) {
        return state.filtros;
    },
}
export const actions = {
    FaturasAgrupadoReferencia(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(`pre-faturas` + payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    PreFaturasPorReferencia(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(`pre-faturas`, payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    getDetalhePreFatura(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(`pre-faturas/detalhar/` + payload.contratoId + '/' + payload.ano + '/' + payload.mes)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    selecionar(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(`pre-faturas/selecionar`, payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    selecionarTodasPreFaturas(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(`pre-faturas/selecionar-todos`, payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    retornarQuantidadeSelecionada(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(`pre-faturas/selecionadas` + payload.referencia)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    gerarMensalidades(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(`faturas/mensalidades`, payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    estornoPrefatura(context, payload) {
        return new Promise((resolve, reject) => {
            axios.put(`pre-faturas/` + payload.referencia + "/estornar", payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    obterFazendas(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(`fazendas/obter-fazendas`, payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    obterPlanos(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(`planos/obter-planos`, payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    obterClasses(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(`contas-energia/obter-classe`, payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    obterSubClasses(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(`contas-energia/obter-subclasse`, payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    obterSituacao(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(`contratos/obter-situacoes`, payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    recalcularPreFatura(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get('pre-faturas/recalcular/' + payload.pre_fatura_id + '/pre-fatura', payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })

        })
    },
    recalcularPreFaturas(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get('pre-faturas/recalcular/' + payload.referencia)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })

        })
    }

}



// WEBPACK FOOTER //
// ./src/store/modules/prefatura.js